export default {
  en: {
    pageelements: {
      simulatorshowoff: {
        heading: 'The Simulator – the heart of the platform',
        description: 'Communicate live with <b>virtual ATC</b> along real or custom routes. Beginner mode with suggestions or individual pro settings <b>with frequency changer</b>, <b>flight plan</b>, <b>radio noise</b>, and <b>aircraft selection</b>. <br><br>Sessions are saved and can be continued at any time.',
        practicenow: 'Practice now for free',
        demo: 'View Demo',
      },
      indexschoolshowoff: {
        heading: 'School – Your aviation training center',
        description: 'The School area is your dedicated training hub on Learn ATC. Here you’ll find all modules to build and sharpen your radio communication skills – from the Listening Trainer for comprehension, to the Spelling Trainer for mastering the NATO/ICAO alphabet, to realistic Scenarios without fixed solution paths, and the complete set of official exam question banks for BZF and AZF. Theory and practice come together, so you can train step by step and gain confidence for both exams and real cockpit communication.',

        bento1_heading: 'Lections – theory with practical application',
        bento1_description: 'Over 11 clearly structured chapters with cross-references to matching exercises. Switch at any time to the simulator, scenarios, or question banks and anchor theory directly in practice.',

        bento2_heading: 'Official exam questions – always up to date',
        bento2_description: 'For radio telephony certificates BZF I/II and AZF/AZF E we use the official question catalogues published by the German Federal Network Agency (knowledge part). For PPL(A/H), LAPL(A/H), SPL and BPL we prepare you in line with the ECQB: we cover the authority-published material and train closely to the ECQB learning objectives. Note that the ECQB also contains non-public items that only appear in the actual exam.',
      },
      builtfor: {
        heading: 'Built for student pilots & flight schools...',
        heading_2: 'Three Profits of many more:',

        card1: {
          title: 'Student pilots',
          l1: 'Targeted preparation for BZF & AZF',
          l2: 'Confident readbacks and clear phraseology',
          l3: 'Training between flight lessons',
        },
        card2: {
          title: 'Flight schools',
          l1: 'Modern complement to classroom instruction',
          l2: 'Easy to integrate with no extra effort',
          l3: 'Multi-seat licenses for classes',
        },

        card3: {
          category: 'Hands on',
          title: 'Realistic ATC communication',
          text: 'From taxi clearance to landing - practice complete radio dialogs in the simulator'
        },
        card4: {
          category: 'Efficient',
          title: 'Fewer expensive flight hours',
          text: 'Step into the cockpit prepared: clean readbacks, clear phraseology',
        },
        card5: {
          category: 'Flexible',
          title: 'Training in the browser',
          text: 'Start anytime, no installation, sessions can be saved',
        }
      },
      thepeople: {
        heading: 'The people behind Learn-ATC',
        description: 'Behind learn-atc.com are two founders who combine a passion for aviation with product and engineering expertise.',
        team_members: {
          fabian: {
            text: 'Software developer and pilot in training living in Austria. As the initiator, he drives technical development and brings the cockpit perspective directly into the simulator.<br><br>“I built Learn ATC because I struggled to get enough realistic radio practice between lessons. With our simulator and trainers, you can rehearse until phraseology and readbacks become second nature—at home, on your schedule.”',
            name: 'Fabian Wagner',
            traitone: 'Tech lead',
            traittwo: 'Sailplane student pilot',
            alt: 'Fabian, Co-Founder and Sailplane student pilot',
          },
          tobias: {
            text: 'German-based aviation enthusiast and expert in digital products. As product manager, he translates training requirements into clear features and ensures a user-centered, didactically sound experience.<br><br>“Our goal is to deliver realistic, accessible, and efficient ATC training. We focus on what moves the needle—authentic ATC dialogue, clear structure, and tools that save cockpit time while building real confidence.”',
            name: 'Tobias Rösner',
            traitone: 'Product manager',
            traittwo: 'Innovative contributor',
            alt: 'Tobias, Co-Founder and Innovative contributor',
          }
        }
      },
      whatisatc: {
        heading: 'What is ATC?',
        p1: 'Air Traffic Control (ATC), ensures the <b>safe and efficient movement</b> in the skies and on the ground, <b>manage and control</b> flight paths, <b>prevent collisions</b> of passing vehicles, and coordinating <b>takeoffs and landings</b>.',
        p2: 'ATC plays a critical role in aviation safety. Using advanced technology and skilled controllers, ATC keeps airspace organized, minimizes delays, and ensures smooth operations for airlines and passengers alike.'
      },
      features: {
        heading: 'Some features at a glance',
        text: 'Brief overview – find the details on the Features page.',
        button: 'See Features in Detail',

        cards: {
          simulator: {
            title: 'Radio Com. Simulator',
            description: 'Train your responses with our <b>realistic radio communication simulator</b>.',
          },
          questions: {
            title: 'Official Questions',
            description: 'Get the whole official <b>ECQB question</b> pool to practice for your <b>ATC exams</b>.'
          },
          training: {
            title: 'Training Tools',
            description: 'Use our <b>training tools</b> to improve your <b>ATC communication</b> skills.',
          },
          scenarios: {
            title: 'Reallife Scenarios',
            description: 'Practice with <b>real-life scenarios</b> and <b>ATC communication</b> challenges.'
          },
          community: {
            title: 'Aviator Community',
            description: 'Connect with other <b>aviators</b> and <b>ATC students</b> to share experiences and learn from each other.',
          },
          knowledgebase: {
            title: 'Knowledgebase',
            description: 'Access our <b>knowledgebase</b> to learn more about <b>ATC communication</b> and aviation.',
          }
        }
      },
      readyfortakeoff: {
        heading: 'Ready for takeoff?',
        text: 'Our platform offers a unique and immersive learning experience, combining real-world scenarios with advanced technology to help you master ATC communication. Our interactive lessons, realistic simulations, and expert guidance will help you build the skills and confidence you need to succeed in the skies.<br>-<br>Try Learn ATC in your browser now - free and with no installation',
        b2b: 'Flightschool or B2B? Check out, what LATC can do for you!',
        tryfree: 'Try for free now',
        clickhere: 'Click here',
      }
    }
  },
  de: {
    pageelements: {
      simulatorshowoff: {
        heading: 'Der Simulator – das Herz der Plattform',
        description: 'Kommuniziere live mit <b>virtuellem ATC</b> entlang echter oder individueller Routen. Anfänger-Modus mit Vorschlägen oder individuelle Profi-Einstellungen <b>mit Frequenzwechsel</b>, <b>Flugplan</b>, <b>Funkrauschen</b> und <b>Flugzeugauswahl</b>. <br><br>Sitzungen werden gespeichert und können jederzeit fortgesetzt werden.',
        practicenow: 'Jetzt kostenlos üben',
        demo: 'Demo ansehen',
      },
      indexschoolshowoff: {
        heading: 'Schule – Dein Ausbildungszentrum für Luftfahrt',
        description: 'Der Schulungsbereich ist dein persönliches Trainingszentrum auf Learn ATC. Hier findest du alle Module, um deine Funkkommunikationsfähigkeiten aufzubauen und zu schärfen – vom Hörtrainer für das Verständnis, über den Buchstabiertrainer für die Beherrschung des NATO/ICAO-Alphabets, bis hin zu realistischen Szenarien ohne feste Lösungswege und dem kompletten Satz offizieller Prüfungsfragekataloge für BZF und AZF. Theorie und Praxis kommen zusammen, sodass du Schritt für Schritt trainieren und Selbstvertrauen für Prüfungen und echte Cockpitkommunikation gewinnen kannst.',

        bento1_heading: 'Lektionen – Theorie mit praktischer Anwendung',
        bento1_description: 'Über 11 klar strukturierte Kapitel mit Querverweisen zu passenden Übungen. Wechsle jederzeit in den Simulator, Szenarien oder Fragekataloge und verankere die Theorie direkt in der Praxis.',

        bento2_heading: 'Offizielle Prüfungsfragen – immer aktuell',
        bento2_description: 'Für die Funkzeugnisse BZF I/II und AZF/AZF E verwenden wir die offiziellen Fragekataloge der Bundesnetzagentur (Wissensteil). Für PPL(A/H), LAPL(A/H), SPL und BPL bereiten wir dich gemäß ECQB vor: Wir decken die von den Behörden veröffentlichten Materialien ab und trainieren eng an den Lernzielen des ECQB. Beachte, dass das ECQB auch nicht-öffentliche Fragen enthält, die nur in der tatsächlichen Prüfung erscheinen.',
      },
      builtfor: {
        heading: 'Entwickelt für Flugschüler & Flugschulen...',
        heading_2: 'Drei Vorteile von vielen:',

        card1: {
          title: 'Flugschüler',
          l1: 'Gezielte Vorbereitung auf BZF & AZF',
          l2: 'Sichere Readbacks und klare Phraseologie',
          l3: 'Training zwischen den Flugstunden',
        },
        card2: {
          title: 'Flugschulen',
          l1: 'Moderne Ergänzung zum Unterricht',
          l2: 'Einfach zu integrieren ohne Mehraufwand',
          l3: 'Mehrplatzlizenzen für Klassen',
        },

        card3: {
          category: 'Praxisnah',
          title: 'Realistische ATC-Kommunikation',
          text: 'Vom Rollhalt bis zur Landung – übe komplette Funkdialoge im Simulator'
        },
        card4: {
          category: 'Effizient',
          title: 'Weniger teure Flugstunden',
          text: 'Steige vorbereitet ins Cockpit ein: saubere Readbacks, klare Phraseologie',
        },
        card5: {
          category: 'Flexibel',
          title: 'Training im Browser',
          text: 'Jederzeit starten, keine Installation, Sitzungen können gespeichert werden',
        }
      },
      thepeople: {
        heading: 'Die Menschen hinter Learn-ATC',
        description: 'Hinter learn-atc.com stehen zwei Gründer, die Leidenschaft für Luftfahrt mit Produkt- und Ingenieurskompetenz verbinden.',
        team_members: {
          fabian: {
            text: 'Softwareentwickler und Flugschüler aus Österreich. Als Initiator treibt er die technische Entwicklung voran und bringt die Cockpit-Perspektive direkt in den Simulator.<br><br>“Ich habe Learn ATC entwickelt, weil ich zwischen den Stunden nicht genug realistische Funkpraxis hatte. Mit unserem Simulator und den Trainern kannst du üben, bis Phraseologie und Readbacks zur zweiten Natur werden – zu Hause, nach deinem Zeitplan.”',
            name: 'Fabian Wagner',
            traitone: 'Technischer Leiter',
            traittwo: 'Segelflug-Schülerpilot',
            alt: 'Fabian, Mitgründer und Segelflug-Schülerpilot',
          },
          tobias: {
            text: 'Luftfahrt-Enthusiast aus Deutschland und Experte für digitale Produkte. Als Produktmanager übersetzt er Trainingsanforderungen in klare Features und sorgt für eine nutzerzentrierte, didaktisch fundierte Erfahrung.<br><br>“Unser Ziel ist es, realistische, zugängliche und effiziente ATC-Ausbildung zu bieten. Wir konzentrieren uns auf das Wesentliche – authentische ATC-Dialoge, klare Struktur und Tools, die Cockpit-Zeit sparen und echtes Selbstvertrauen aufbauen.”',
            name: 'Tobias Rösner',
            traitone: 'Produktmanager',
            traittwo: 'Innovativer Mitgestalter',
            alt: 'Tobias, Mitgründer und Innovativer Mitgestalter',
          }
        }
      },
      whatisatc: {
        heading: 'Was ist ATC?',
        p1: 'Die Flugsicherung (ATC) gewährleistet die <b>sichere und effiziente Bewegung</b> im Luftraum und am Boden, <b>lenkt und kontrolliert</b> Flugrouten, <b>verhindert Kollisionen</b> von durchfahrenden Fahrzeugen und koordiniert <b>Start- und Landungen</b>.',
        p2: 'ATC spielt eine entscheidende Rolle für die Sicherheit in der Luftfahrt. Durch den Einsatz fortschrittlicher Technologie und qualifizierter Fluglotsen hält ATC den Luftraum organisiert, minimiert Verzögerungen und sorgt für reibungslose Abläufe für Fluggesellschaften und Passagiere.'
      },
      features: {
        heading: 'Einige Features auf einen Blick',
        text: 'Kurzer Überblick – Details findest du auf der Seite Features.',
        button: 'Features im Detail ansehen',

        cards: {
          simulator: {
            title: 'Funk-Kommunikations-Simulator',
            description: 'Trainieren Sie Ihre Reaktionen mit unserem <b>realistischen Funkkommunikations-Simulator</b>.',
          },
          questions: {
            title: 'Offizielle Fragen',
            description: 'Erhalten Sie den gesamten offiziellen <b>ECQB-Fragenpool</b> zur Vorbereitung auf Ihre <b>ATC-Prüfungen</b>.'
          },
          training: {
            title: 'Trainingswerkzeuge',
            description: 'Nutzen Sie unsere <b>Trainingswerkzeuge</b>, um Ihre <b>ATC-Kommunikationsfähigkeiten</b> zu verbessern.',
          },
          scenarios: {
            title: 'Real-Life-Szenarien',
            description: 'Üben Sie mit <b>Real-Life-Szenarien</b> und <b>ATC-Kommunikationsherausforderungen</b>.'
          },
          community: {
            title: 'Aviator Community',
            description: 'Vernetzen Sie sich mit anderen <b>Aviators</b> und <b>ATC-Schülern</b>, um Erfahrungen auszutauschen und voneinander zu lernen.',
          },
          knowledgebase: {
            title: 'Wissensdatenbank',
            description: 'Greifen Sie auf unsere <b>Wissensdatenbank</b> zu, um mehr über <b>ATC-Kommunikation</b> und Luftfahrt zu erfahren.',
          }
        }
      },
      readyfortakeoff: {
        heading: 'Bereit für den Abflug?',
        text: 'Unsere Plattform bietet ein einzigartiges und immersives Lernerlebnis, das reale Szenarien mit modernster Technologie kombiniert, um dir zu helfen, die ATC-Kommunikation zu meistern. Unsere interaktiven Lektionen, realistischen Simulationen und fachkundige Anleitung helfen dir, die Fähigkeiten und das Selbstvertrauen aufzubauen, die du brauchst, um in der Luft erfolgreich zu sein.<br>-<br>Probiere Learn ATC jetzt in deinem Browser aus – kostenlos und ohne Installation',
        b2b: 'Flugschule oder B2B? Schau dir an, was LATC für dich tun kann!',
        tryfree: 'Jetzt kostenlos testen',
        clickhere: 'Klicke hier',
      }
    }
  },
  es: {
    pageelements: {
      simulatorshowoff: {
        heading: 'El Simulador – el corazón de la plataforma',
        description: 'Comunica en vivo con <b>ATC virtual</b> a lo largo de rutas reales o personalizadas. Modo principiante con sugerencias o configuraciones profesionales individuales <b>con cambio de frecuencia</b>, <b>plan de vuelo</b>, <b>ruido de radio</b> y <b>selección de aeronave</b>. <br><br>Las sesiones se guardan y se pueden continuar en cualquier momento.',
        practicenow: 'Practica ahora gratis',
        demo: 'Ver Demo',
      },
      indexschoolshowoff: {
        heading: 'Escuela – Tu centro de formación aeronáutica',
        description: 'El área de Escuela es tu centro de entrenamiento dedicado en Learn ATC. Aquí encontrarás todos los módulos para construir y afinar tus habilidades de comunicación por radio, desde el Entrenador Auditivo para comprensión, hasta el Entrenador de Ortografía para dominar el alfabeto NATO/ICAO, pasando por escenarios realistas sin caminos fijos de solución, y el conjunto completo de bancos de preguntas del examen oficial para BZF y AZF. Teoría y práctica se unen, para que puedas entrenar paso a paso y ganar confianza tanto para los exámenes como para la comunicación real en cabina.',

        bento1_heading: 'Lecciones – teoría con aplicación práctica',
        bento1_description: 'Más de 11 capítulos claramente estructurados con referencias cruzadas a ejercicios correspondientes. Cambia en cualquier momento al simulador, escenarios o bancos de preguntas y ancla la teoría directamente en la práctica.',

        bento2_heading: 'Preguntas oficiales del examen – siempre actualizadas',
        bento2_description: 'Para los certificados de radiotelefonía BZF I/II y AZF/AZF E utilizamos los catálogos de preguntas oficiales publicados por la Agencia Federal de Redes alemana (parte del conocimiento). Para PPL(A/H), LAPL(A/H), SPL y BPL te preparamos conforme al ECQB: cubrimos el material publicado por la autoridad y entrenamos estrechamente con los objetivos de aprendizaje del ECQB. Ten en cuenta que el ECQB también contiene elementos no públicos que solo aparecen en el examen real.',
      },
      builtfor: {
        heading: 'Diseñado para pilotos estudiantes y escuelas de vuelo...',
        heading_2: 'Tres beneficios de muchos más:',

        card1: {
          title: 'Pilotos estudiantes',
          l1: 'Preparación específica para BZF & AZF',
          l2: 'Lecturas seguras y fraseología clara',
          l3: 'Entrenamiento entre lecciones de vuelo',
        },
        card2: {
          title: 'Escuelas de vuelo',
          l1: 'Complemento moderno a la instrucción en clase',
          l2: 'Fácil integración sin esfuerzo adicional',
          l3: 'Licencias multiusuario para clases',
        },

        card3: {
          category: 'Práctico',
          title: 'Comunicación ATC realista',
          text: 'Desde el permiso de rodaje hasta el aterrizaje, practica diálogos completos por radio en el simulador'
        },
        card4: {
          category: 'Eficiente',
          title: 'Menos horas de vuelo costosas',
          text: 'Entra en la cabina preparado: lecturas limpias, fraseología clara',
        },
        card5: {
          category: 'Flexible',
          title: 'Entrenamiento en el navegador',
          text: 'Comienza en cualquier momento, sin instalación, las sesiones se pueden guardar',
        }
      },
      thepeople: {
        heading: 'Las personas detrás de Learn-ATC',
        description: 'Detrás de learn-atc.com hay dos fundadores que combinan una pasión por la aviación con experiencia en productos e ingeniería.',
        team_members: {
          fabian: {
            text: 'Desarrollador de software y piloto en formación que vive en Austria. Como iniciador, impulsa el desarrollo técnico y aporta la perspectiva de la cabina directamente al simulador.<br><br>“Creé Learn ATC porque luchaba por obtener suficiente práctica realista de radio entre lecciones. Con nuestro simulador y entrenadores, puedes ensayar hasta que la fraseología y las lecturas se conviertan en algo natural, en casa, a tu ritmo.”',
            name: 'Fabian Wagner',
            traitone: 'Líder técnico',
            traittwo: 'Piloto estudiante de planeador',
            alt: 'Fabian, Co-Fundador y Piloto estudiante de planeador',
          },
          tobias: {
            text: 'Entusiasta de la aviación con sede en Alemania y experto en productos digitales. Como gerente de producto, traduce los requisitos de entrenamiento en características claras y asegura una experiencia centrada en el usuario y didácticamente sólida.<br><br>“Nuestro objetivo es ofrecer un entrenamiento ATC realista, accesible y eficiente. Nos enfocamos en lo que realmente importa: diálogos ATC auténticos, estructura clara y herramientas que ahorran tiempo en la cabina mientras construyen confianza real.”',
            name: 'Tobias Rösner',
            traitone: 'Gerente de producto',
            traittwo: 'Contribuyente innovador',
            alt: 'Tobias, Co-Fundador y Contribuyente innovador',
          }
        }
      },
      whatisatc: {
        heading: '¿Qué es ATC?',
        p1: 'El Control de Tráfico Aéreo (ATC) garantiza el <b>movimiento seguro y eficiente</b> en el cielo y en tierra, <b>gestiona y controla</b> las rutas de vuelo, <b>previene colisiones</b> entre vehículos que pasan y coordina <b>despegues y aterrizajes</b>.',
        p2: 'ATC juega un papel crítico en la seguridad de la aviación. Utilizando tecnología avanzada y controladores capacitados, ATC mantiene el espacio aéreo organizado, minimiza retrasos y asegura operaciones fluidas para aerolíneas y pasajeros por igual.'
      },
      features: {
        heading: 'Algunas características a simple vista',
        text: 'Breve resumen: encuentra los detalles en la página de Características.',
        button: 'Ver Características en Detalle',

        cards: {
          simulator: {
            title: 'Simulador de Comunicación por Radio',
            description: 'Entrena tus respuestas con nuestro <b>simulador de comunicación por radio realista</b>.',
          },
          questions: {
            title: 'Preguntas Oficiales',
            description: 'Obtén todo el <b>pool de preguntas oficiales ECQB</b> para practicar tus <b>exámenes ATC</b>.'
          },
          training: {
            title: 'Herramientas de Entrenamiento',
            description: 'Utiliza nuestras <b>herramientas de entrenamiento</b> para mejorar tus habilidades de <b>comunicación ATC</b>.',
          },
          scenarios: {
            title: 'Escenarios de la Vida Real',
            description: 'Practica con <b>escenarios de la vida real</b> y desafíos de <b>comunicación ATC</b>.'
          },
          community: {
            title: 'Comunidad Aviadora',
            description: 'Conéctate con otros <b>aviadores</b> y <b>estudiantes ATC</b> para compartir experiencias y aprender unos de otros.',
          },
          knowledgebase: {
            title: 'Base de Conocimientos',
            description: 'Accede a nuestra <b>base de conocimientos</b> para aprender más sobre <b>comunicación ATC</b> y aviación.',
          }
        }
      },
      readyfortakeoff: {
        heading: '¿Listo para el despegue?',
        text: 'Nuestra plataforma ofrece una experiencia de aprendizaje única e inmersiva, que combina escenarios del mundo real con tecnología avanzada para ayudarte a dominar la comunicación ATC. Nuestras lecciones interactivas, simulaciones realistas y orientación experta te ayudarán a desarrollar las habilidades y la confianza que necesitas para tener éxito en los cielos.<br>-<br>Prueba Learn ATC en tu navegador ahora, gratis y sin instalación',
        b2b: '¿Escuela de vuelo o B2B? ¡Descubre lo que LATC puede hacer por ti!',
        tryfree: 'Pruébalo gratis ahora',
        clickhere: 'Haz clic aquí',
      }
    }
  },
  uk: {
    pageelements: {
      simulatorshowoff: {
        heading: 'Симулятор – серце платформи',
        description: 'Спілкуйтеся в реальному часі з <b>віртуальним ATC</b> за реальними або індивідуальними маршрутами. Режим для початківців з підказками або індивідуальні професійні налаштування <b>з перемиканням частоти</b>, <b>планом польоту</b>, <b>радіошумом</b> та <b>вибором літака</b>. <br><br>Сесії зберігаються та можуть бути продовжені в будь-який час.',
        practicenow: 'Практикуйтеся зараз безкоштовно',
        demo: 'Переглянути демо',
      },
      indexschoolshowoff: {
        heading: 'Школа – ваш навчальний центр авіації',
        description: 'Розділ Школа – це ваш спеціалізований навчальний центр на Learn ATC. Тут ви знайдете всі модулі для розвитку та вдосконалення своїх навичок радіозв’язку – від Тренажера слуху для розуміння, до Тренажера правопису для освоєння алфавіту НАТО/ICAO, до реалістичних Сценаріїв без фіксованих шляхів вирішення, а також повний набір офіційних банків питань іспитів для BZF та AZF. Теорія та практика об’єднуються, щоб ви могли тренуватися крок за кроком і здобувати впевненість як для іспитів, так і для реального спілкування в кабіні.',

        bento1_heading: 'Уроки – теорія з практичним застосуванням',
        bento1_description: 'Більше 11 чітко структурованих розділів з перехресними посиланнями на відповідні вправи. Перемикайтеся в будь-який час на симулятор, сценарії або банки питань і закріплюйте теорію безпосередньо в практиці.',

        bento2_heading: 'Офіційні питання іспиту – завжди актуальні',
        bento2_description: 'Для сертифікатів радіозв’язку BZF I/II та AZF/AZF E ми використовуємо офіційні каталоги питань, опубліковані Федеральною мережева агенцією Німеччини (частина знань). Для PPL(A/H), LAPL(A/H), SPL та BPL ми готуємо вас відповідно до ECQB: ми охоплюємо матеріали, опубліковані владою, і тренуємося відповідно до навчальних цілей ECQB. Зверніть увагу, що ECQB також містить непублічні елементи, які з’являються лише на реальному іспиті.',
      },
      builtfor: {
        heading: 'Розроблено для студентів пілотів та авіашкіл...',
        heading_2: 'Три переваги з багатьох:',

        card1: {
          title: 'Студенти пілоти',
          l1: 'Цілеспрямована підготовка до BZF та AZF',
          l2: 'Впевнені прочитування та чітка фразеологія',
          l3: 'Тренування між польотами',
        },
        card2: {
          title: 'Авіашколи',
          l1: 'Сучасне доповнення до навчання в класі',
          l2: 'Легко інтегрується без додаткових зусиль',
          l3: 'Багатомісні ліцензії для класів',
        },

        card3: {
          category: 'Практично',
          title: 'Реалістичний зв’язок ATC',
          text: 'Від дозволу на руління до посадки – практикуйте повні радіодіалоги в симуляторі'
        },
        card4: {
          category: 'Ефективно',
          title: 'Менше дорогих годин польоту',
          text: 'Зайдіть у кабіну підготовленими: чисті прочитування, чітка фразеологія',
        },
        card5: {
          category: 'Гнучко',
          title: 'Тренування в браузері',
          text: 'Починайте в будь-який час, без встановлення, сесії можна зберігати',
        }
      },
      thepeople: {
        heading: 'Люди за Learn-ATC',
        description: 'За learn-atc.com стоять два засновники, які поєднують пристрасть до авіації з експертизою в продуктах та інженерії.',
        team_members: {
          fabian: {
            text: 'Розробник програмного забезпечення та пілот у навчанні з Австрії. Як ініціатор, він керує технічним розвитком і приносить перспективу кабіни безпосередньо в симулятор.<br><br>“Я створив Learn ATC, тому що мені не вистачало реалістичної практики радіозв’язку між уроками. З нашим симулятором і тренажерами ви можете репетирувати, поки фразеологія та прочитування не стануть другою природою – вдома, за вашим розкладом.”',
            name: 'Фабіан Вагнер',
            traitone: 'Технічний лідер',
            traittwo: 'Пілот-учень планера',
            alt: 'Фабіан, співзасновник і пілот-учень планера',
          },
          tobias: {
            text: 'Прихильник авіації з Німеччини та експерт з цифрових продуктів. Як менеджер продукту, він перетворює вимоги до навчання на чіткі функції та забезпечує орієнтований на користувача, дидактично обґрунтований досвід.<br><br>“Наша мета – забезпечити реалістичне, доступне та ефективне навчання ATC. Ми зосереджуємося на тому, що має значення – автентичні діалоги ATC, чітка структура та інструменти, які економлять час у кабіні та створюють справжню впевненість.”',
            name: 'Тобіас Резнер',
            traitone: 'Менеджер продукту',
            traittwo: 'Інноваційний учасник',
            alt: 'Тобіас, співзасновник і інноваційний учасник',
          }
        }
      },
      whatisatc: {
        heading: 'Що таке ATC?',
        p1: 'Контроль повітряного руху (ATC) забезпечує <b>безпечний та ефективний рух</b> у небі та на землі, <b>керує та контролює</b> маршрути польотів, <b>запобігає зіткненням</b> між транспортними засобами та координує <b>виліт та посадку</b>.',
        p2: 'ATC відіграє критичну роль у безпеці авіації. Використовуючи передові технології та кваліфікованих контролерів, ATC підтримує організованість повітряного простору, мінімізує затримки та забезпечує плавність операцій для авіакомпаній і пасажирів.'
      },
      features: {
        heading: 'Деякі функції на перший погляд',
        text: 'Короткий огляд – знайдіть деталі на сторінці Функції.',
        button: 'Переглянути функції детально',

        cards: {
          simulator: {
            title: 'Симулятор радіозв’язку',
            description: 'Тренуйте свої реакції з нашим <b>реалістичним симулятором радіозв’язку</b>.',
          },
          questions: {
            title: 'Офіційні питання',
            description: 'Отримайте весь <b>офіційний пул питань ECQB</b> для підготовки до ваших <b>ATC іспитів</b>.'
          },
          training: {
            title: 'Навчальні інструменти',
            description: 'Використовуйте наші <b>навчальні інструменти</b> для покращення своїх навичок <b>ATC зв’язку</b>.',
          },
          scenarios: {
            title: 'Сценарії реального життя',
            description: 'Практикуйтеся з <b>сценаріями реального життя</b> та викликами <b>ATC зв’язку</b>.'
          },
          community: {
            title: 'Спільнота авіаторів',
            description: 'З’єднуйтеся з іншими <b>авіаторами</b> та <b>ATC студентами</b>, щоб обмінюватися досвідом та вчитися один у одного.',
          },
          knowledgebase: {
            title: 'База знань',
            description: 'Отримайте доступ до нашої <b>бази знань</b>, щоб дізнатися більше про <b>ATC зв’язок</b> та авіацію.',
          }
        }
      },
      readyfortakeoff: {
        heading: 'Готові до зльоту?',
        text: 'Наша платформа пропонує унікальний та захоплюючий досвід навчання, поєднуючи реальні сценарії з передовими технологіями, щоб допомогти вам освоїти ATC зв’язок. Наші інтерактивні уроки, реалістичні симуляції та експертні поради допоможуть вам розвинути навички та впевненість, необхідні для успіху в небі.<br>-<br>Спробуйте Learn ATC у своєму браузері зараз – безкоштовно та без встановлення',
        b2b: 'Льотна школа або B2B? Дізнайтеся, що LATC може зробити для вас!',
        tryfree: 'Спробуйте безкоштовно зараз',
        clickhere: 'Клацніть тут',
      }
    }
  }
}
